module.exports = __webpack_public_path__ + "static/img/IPimg4.281300e1.png";